<template>
    <div class="games">
        <LoadingScreen v-if="loadingPage" />
        <template v-else>
            <EmptyComponent v-if="dataSource.length === 0" text="no data" />
            <div v-else>
                <section class="games__section" v-for="section in productSections" :key="section.key">
                    <img v-if="section.banner" class="games__section-banner" :src="sectionBanner(section.banner)" :alt="section.key" />
                    <div class="games__list">
                <div class="games__item" v-for="(v, i) in section.games" :key="v.id || i">
                    <div 
                        v-if="v.banner === 'lotto-6-45' && $store.state.isShow645 || v.banner === 'lotto-5-45'  && $store.state.isShow545 || CT_GAME_SLUG.LOTTO_459.includes(v.banner?.toLowerCase()) && $store.state.isShow459" 
                        class="games__games-item-banner" 
                    >
                        <img v-if="!$store.state.isScreenMobile" :src="require(`@/public/theme/${themePath}/img/banner/${v.banner}.png`)" @error="handleBannerImageError($event, v.banner)" />
                        <img v-else :src="require(`@/public/theme/${themePath}/img/banner/${v.banner}-mobile.png`)" @error="handleBannerImageError($event, v.banner + '-mobile')" />
                    </div>
                    <div class="games__item-header" v-if="section.key === '5-90'">
                        <span>{{ getTranslatedText(`${v.isPariMutuelLotto ? '' : 'loto '}${v.title}`) }}</span>
                    </div>
                    <div class="games__item-list-number">
                        <div class="games__item-item-number" v-for="(value, index) in v.listRanDomNumber" :key="index" @click="onClickGames(v, value, index)">
                            <span v-if="v.isPariMutuelLotto">{{ getTranslatedText('play') }}</span>
                            <span v-else>{{ value.label ||
                                getTranslatedText(`${v.title} [number]`, {
                                    number: value.number,
                                })
                            }}</span>
                        </div>
                    </div>
                </div>
                    </div>
                </section>
            </div>
        </template>
    </div>
</template>

<script>
import pathAssetsMixins from '@/mixins/pathAssets/path-assets-mixins'
import languageMixins from '@/mixins/language/language-mixins'
import getListGames from '@/mixins/getListGames/get-list-games-mixin'
import LoadingScreen from '@/components/common/loading/index.vue'
import EmptyComponent from '@/components/common/empty/index.vue'
import routerMixins from '@/mixins/router/router-mixin'
import EventBus from '@/utils/EventBus'
import { isObjEmpty } from '@/utils/utils'
import { CT_GAME_SLUG } from '@/constants/game'
import { productByKey } from '@/constants/game/products'

export default {
    mixins: [pathAssetsMixins, languageMixins, getListGames, routerMixins],
    components: { LoadingScreen, EmptyComponent },
    computed: {
        productSections() {
            const order = ['5-90', '4-80', '4-52', '6-45', '4-59', '5-45']
            const banners = {
                '5-90': 'banner-590',
                '4-80': 'banner-480',
                '4-52': 'banner-452',
            }
            const groups = {}
            this.dataSource.forEach((card) => {
                const key = card.productKey || 'other'
                groups[key] = groups[key] || []
                groups[key].push(card)
            })
            return order
                .filter((key) => groups[key] && groups[key].length)
                .map((key) => ({
                    key,
                    banner: banners[key] || '',
                    games: groups[key],
                }))
        },
    },
    data() {
        return {
            dataSource: [],
            loadingPage: true,
            CT_GAME_SLUG,
            dataBanner: [
                {
                    name: 'isShow645',
                    img: 'banner-645',
                },
                {
                    name: 'isShow459',
                    img: 'banner-459',
                },
                {
                    name: 'isShow545',
                    img: 'banner-645'
                }
            ]
        }
    },
    methods: {
        sectionBanner(name) {
            return require(`@/public/theme/${this.themePath}/img/banner/${name}.png`)
        },
        handleBannerImageError(event, bannerName) {
            const img = event.target;
            const currentSrc = img.src;
            
            // Prevent infinite loop by tracking error attempts
            if (img.dataset.errorAttempted) {
                // Already tried fallback, hide the image
                img.style.display = 'none';
                return;
            }
            
            // Mark that we've attempted error handling
            img.dataset.errorAttempted = 'true';
            
            // Try fallback to default theme
            if (this.themePath !== 'default') {
                try {
                    img.src = require(`@/public/theme/default/img/banner/${bannerName}.png`);
                } catch (e) {
                    // If default theme also fails, hide the image
                    img.style.display = 'none';
                }
            } else {
                // Already on default theme and failed, hide the image
                img.style.display = 'none';
            }
        },
        
        onClickGames(games, itemGame, index) {
            games.listRanDomNumber[index].active = true
            let param = {
                title: games.title,
                gameNumber: itemGame.number,
                name: itemGame.slug || `${games.name}`,
                price: itemGame?.price || games.price,
                numberQp: games.title === 'turbo' ? 2 : itemGame.number,
                listRanDomNumber: games.listRanDomNumber,
                isPariMutuelLotto: games.isPariMutuelLotto,
                bet_options: games?.bet_options || [],
                jackpot: games.jackpot,
                productStep: games.productStep,
                productKey: games.productKey,
                gameType: games.gameType,
                api: games.api,
                balls: games.balls,
                parentId: games.parentId,
                preserveSlug: Boolean(itemGame.slug || games.preserveSlug),
                wagerConfig: itemGame.wagerConfig || games.wagerConfig,
            }

            if(!isObjEmpty(itemGame.allowed_picks)) {
                param['allowed_picks'] = itemGame.allowed_picks
                param['numberQp'] = itemGame.allowed_picks?.max || param['numberQp']
            }
            
            // Add bankers if available
            if(itemGame.bankers && Array.isArray(itemGame.bankers) && itemGame.bankers.length > 0) {
                param['bankers'] = itemGame.bankers
            }

            if (games.isPariMutuelLotto) {
                param['maxPicks'] = games.listRanDomNumber[0].maxPicks
                param['numberQp'] = games.listRanDomNumber[0].number
            }
            
            const product = productByKey(games.productKey)
            const route = product?.route || 'loto-5-90'
            localStorage.setItem('configGame', JSON.stringify(param))
            this.routerPush(`/games-loto?loto=${route}`)
            this.$store.state.stepCart = product?.step || 1
            EventBus.$emit('on-change-active-menu', `/games-loto?loto=${route}`)
        },
    },
}
</script>

<style lang="scss">
@import '~ThemePath/scss/games/_list.scss';
</style>
